var $51e037198cdb0f82$exports = {};
$51e037198cdb0f82$exports = {
    "pending": `v\xe4ntande`
};


export {$51e037198cdb0f82$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
